import { useEffect, useState } from 'react';

/**
 * Use this hook when you need to do something only after the app has mounted
 * on the client.
 *
 * Shamelessly stolen from here:
 * https://www.joshwcomeau.com/react/the-perils-of-rehydration/
 *
 * 👆 this is an excellent read if you want to understand the difference between
 * rendering and rehydrating.
 */
export function useHasMounted() {
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);
  return hasMounted;
}
